import type { ModeSlug } from "./modes-registry";

/**
 * The single authority for "is this mode active for the current path?" — shared
 * by the ModeRail (the vertical left nav) and ModePills (the top-bar nav) so the
 * two cannot drift. A mode is active on its own route and anything beneath it;
 * an orphan (mode-agnostic) route like `/o/<uid>` anchors to its origin mode via
 * `?from`, so passing `from` keeps that mode lit even when the path carries no
 * mode (the rail uses this; the pills pass no `from` and get the same base-match
 * behavior).
 *
 * Folds the near-verbatim `isModeActive` fork the two nav surfaces each carried
 * (CONSOLIDATION-ROLLOUT-PLAN §3c).
 */
export function isModeActive(
  pathname: string,
  mode: ModeSlug,
  projectSlug?: string | null,
  from?: string | null,
): boolean {
  const base = projectSlug ? `/projects/${projectSlug}/${mode}` : `/${mode}`;
  if (pathname === base || pathname.startsWith(`${base}/`)) return true;
  return from === mode;
}
